import styled from "styled-components";

// export const FilterContainer = styled.div`
//   overflow: visible;

//   .filter-header {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 1rem 0;
//     cursor: pointer;
//     user-select: none;

//     h3 {
//       color: #203b34;
//       font-size: 1.1rem;
//       font-weight: 600;
//       margin: 0;
//       display: flex;
//       align-items: center;
//       gap: 0.5rem;
//     }

//     .toggle-icon {
//       color: #6c757d;
//       transition: transform 0.3s ease;

//       &.open {
//         transform: rotate(180deg);
//       }
//     }
//   }

//   .filter-body {
//     max-height: 0;
//     overflow: visible;
//     opacity: 0;
//     transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;

//     &.open {
//       max-height: 1000px;
//       opacity: 1;
//       padding-top: 1rem;
//     }

//     > form {
//       min-height: 0;
//     }
//   }
// `;

export const FilterContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  /* overflow: hidden; */
  margin-bottom: 30px;

  .accordion-item {
    border: none;
    background: transparent;
  }

  .accordion-button {
    background: white;
    color: #203b34;
    font-size: 16px;
    font-weight: 600;
    padding: 24px;
    border: none;
    box-shadow: none;

    &:not(.collapsed) {
      background: white;
      color: #203b34;
      border-bottom: 1px solid #e9ecef;
    }

    &:focus {
      box-shadow: none;
      border-color: transparent;
    }

    &::after {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23203b34'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
    }

    &:hover {
      background: #f8f9fa;
    }
  }

  .accordion-body {
    padding: 24px;
    background: white;
  }
`;

export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const FilterActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;

  @media (max-width: 768px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

// export const FilterButton = styled.button`
//   padding: 0.75rem 1.5rem;
//   border: none;
//   border-radius: 8px;
//   font-weight: 600;
//   font-size: 0.9rem;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   justify-content: center;

//   &.primary {
//     background: #203b34;
//     color: white;

//     &:hover {
//       background: #1a2f28;
//       transform: translateY(-1px);
//       box-shadow: 0 4px 8px rgba(32, 59, 52, 0.3);
//     }
//   }

//   &.secondary {
//     background: #6c757d;
//     color: white;

//     &:hover {
//       background: #545b62;
//       transform: translateY(-1px);
//       box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
//     }
//   }

//   &:active {
//     transform: translateY(0);
//   }

//   i {
//     font-size: 1rem;
//   }
// `;

export const FilterButton = styled.button`
  background: #203b34;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 14px;
  }

  &:hover {
    background: #2d5347;
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(32, 59, 52, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ClearButton = styled.button`
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 14px;
  }

  &:hover {
    background: #5a6268;
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(108, 117, 125, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;
